import * as React from 'react';

import * as styles from './QuickLinks.css';
import { AvgPriceInformer } from '../AvgPriceInformer';
import { QuickLinksList } from './components/QuickLinksList/QuickLinksList';
import { QuickLinksSuburbanTrap } from './components/QuickLinksSuburbanTrap';
import { trackQuickLinksView } from './utils/tracking';
import { IAvgPriceInformer } from '../../../types/offersData';
import { IQuickLink } from '../../../types/quickLinks';

export interface IQuickLinksStateProps {
  level: number | null;
  linkGroups: IQuickLink[][] | null;
  countrysideBlackFridayLink?: string;
  isSuburbanListing: boolean;
  avgPriceInformer: IAvgPriceInformer | null;
  isRent: boolean;
}

export interface IQuickLinksProps extends IQuickLinksStateProps {
  banner?: React.ReactNode;
}

export class QuickLinks extends React.PureComponent<IQuickLinksProps> {
  public componentDidMount() {
    if (this.props.level !== null) {
      trackQuickLinksView(this.props.level);
    }
  }

  public render() {
    const { isSuburbanListing, level, linkGroups, countrysideBlackFridayLink, banner, avgPriceInformer, isRent } =
      this.props;

    const hasQuickLinks = level !== null && linkGroups !== null;

    return (
      <div className={styles['wrapper']}>
        {avgPriceInformer && <AvgPriceInformer avgPriceInformer={avgPriceInformer} isRent={isRent} />}
        {hasQuickLinks && <QuickLinksList linkGroups={linkGroups} level={level} />}
        {isSuburbanListing && (
          <QuickLinksSuburbanTrap countrysideBlackFridayLink={countrysideBlackFridayLink} banner={banner} />
        )}
      </div>
    );
  }
}
